/** @jsxImportSource @emotion/react */
import { IconName } from '../../icons';
import { useTheme } from '../../ThemeProvider';
import { createStyles } from '../../utils';
import { Icon } from '../Icon';
import { Typography } from '../Typography';

export interface Props {
  value: string;
  variant?: 'danger' | 'success' | 'primary' | 'neutral';
  iconName?: IconName;
  size?: 'small' | 'large';
}

export const Tag = ({
  value,
  variant = 'primary',
  iconName,
  size = 'small',
}: Props) => {
  const styles = useStyles();
  const { spacing } = useTheme();
  const iconSize =
    size === 'small'
      ? `calc(${spacing.xxxs} + (${spacing.xxxs} / 4) )`
      : `calc(${spacing.xxxs} + (${spacing.xxxs} / 2) )`;

  return (
    <div css={[styles['main'], styles[variant], styles[size]]}>
      {iconName && (
        <div id="icon">
          <Icon name={iconName} size={iconSize} />
        </div>
      )}
      <Typography variant="captionMedium">{value}</Typography>
    </div>
  );
};

const useStyles = createStyles(({ spacing, palette }) => ({
  main: {
    display: 'flex',
    borderRadius: `calc(${spacing.xxxs} / 2)`,
    gap: `calc(${spacing.xxxs} / 2)`,
    alignItems: 'center',
    padding: `calc(${spacing.xxxs} / 4) calc(${spacing.xxxs} / 2)`,
    width: 'fit-content',
  },
  large: {
    p: {
      fontSize: `calc(${spacing.xxs} - (${spacing.xxxs} / 4)) !important`,
    },
    '#icon': {
      marginTop: `-${spacing.xxxs}`,
    },
  },
  small: {
    '#icon': {
      marginTop: `-${spacing.xxs}`,
    },
  },
  success: {
    backgroundColor: `${palette.success.default}1A`,
    color: palette.success.default,
    svg: {
      color: palette.success.default,
    },
  },
  danger: {
    backgroundColor: `${palette.danger.default}1A`,
    color: palette.danger.default,
    svg: {
      color: palette.danger.default,
    },
  },
  neutral: {
    backgroundColor: `${palette.grey.default}1A`,
    color: palette.grey.default,
    svg: {
      color: palette.grey.default,
    },
  },
  primary: {
    backgroundColor: `${palette.primary.default}1A`,
    color: palette.primary.default,
    svg: {
      color: palette.primary.default,
    },
  },
}));
